<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="知识库结构管理">
      <router-link to="/detection-corpus-structure-new" slot="before-left"><el-button type="primary">新建知识库结构</el-button></router-link>
    </pt-page-title>
    <!-- 筛选 -->
    <pt-page-factor-filter :labels="filterLabels" v-model="filterForm">
      <div>
          <el-button type="primary" @click="handleFilter">筛选</el-button>
      </div>
    </pt-page-factor-filter>
    <!-- 表格 -->
    <pt-detection-corpus-structure-table :category="currentCategoryFilter" ref="table" :tableLabels="tableLabels">
      <template slot-scope="scope">
        <i class="iconfont icon-dingdanchuangjian pointer" @click="goEdit(scope.row)"></i>
        <i class="iconfont icon-shanchu pointer" @click="goDelete(scope.row)"></i>
      </template>
    </pt-detection-corpus-structure-table>
  </div>
</template>

<script>
// 组件class前缀
import { filterFactor, tableLabels } from './detection-corpus-structure-options.js'
import ptDetectionCorpusStructureTable from './pt-detection-corpus-structure-table/withData'
const prefixCls = 'pt-detection-corpus-structure-list'
export default {
  name: 'pt-detection-corpus-structure-list',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    tableLabels () {
      return tableLabels
    }
  },
  components: {
    ptDetectionCorpusStructureTable
  },
  data () {
    return {
      filterLabels: filterFactor,
      filterForm: {},
      currentCategoryFilter: '',
      loading: false
    }
  },
  methods: {
    handleFilter () {
      if (!this.filterForm.type) {
        this.filterForm.type = null
      }
      this.$refs.table.reload(this.filterForm)
    },
    goEdit (data) {
      this.$router.push({ name: 'detection-corpus-structure-update', params: { id: data.id } })
    },
    goDelete (data) {
      this.$confirm('确定要删除一级标题为"' + data.name + '"的知识库结构?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true
        this.$store.dispatch('deleteCorpusStructure', data.id).then(res => {
          this.$refs.table.reload()
          this.$message.success('成功删除了一级标题为"' + data.name + '"的知识库结构!')
          this.loading = false
        }).catch(err => {
          this.loading = false
          console.error(err)
          this.$message.error('删除失败!')
        })
      })
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
